import styled from "styled-components";

export const ProductsContainer = styled.div`
    text-align: center;
`;

export const TabsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
  margin-top: 32px;
  max-width: 1100px;
  padding: 0 12px;
  color: #515151;

  @media (max-width: 1100px) {
    max-width: 900px;
  }

  @media (max-width: 900px) {
    max-width: 850px;
  }

  @media (max-width: 850px) {
    max-width: 600px;
  }

  @media (max-width: 600px) {
    max-width: 450px;
  }
`;

export const TabList = styled.div`
  display: flex;
  // justify-content: space-between;
  margin-bottom: 8px;

  @media (max-width: 499px) {
    gap: 20px;
    flex-direction: column;
  }
`;

export const TabItem = styled.div<{ active: boolean }>`
  flex: 1;
  text-align: center;
  font-family: Nexa;
  font-weight: 700;
  font-style: Bold;
  font-size: 50px;
  leading-trim: NONE;
  line-height: 100%;
  letter-spacing: 0%;
  color: ${({ active }) => (active ? '#f7941d' : '#515151')};
  cursor: pointer;

  @media (max-width: 1100px) {
    font-size: 38px;
  }

  @media (max-width: 900px) {
    font-size: 30px;
  }

  @media (max-width: 499px) {
    font-size: 28px;
  }
`;

export const ProgressBar = styled.div`
  position: relative;
  height: 6px;
  background-color: #e5e5e5;
  border-radius: 999px;
  overflow: hidden;
  margin-top: 32px;
  width: 110%;

  @media (max-width: 499px) {
    margin: auto;
    margin-top: 10px;
    width: 80%;
  }
`;

export const ProgressIndicator = styled.div`
  height: 100%;
  background-color: #f7941d;
  transition: width 0.3s ease-in-out;
  border-radius: 999px;
  position: relative;
  z-index: 2;
`;

export const ImageContainer = styled.div`

`

export const DescriptionContainer = styled.div`
  width: 80%;
  margin: auto;
  margin-bottom: 72px;
  font-family: Open Sans;
  font-weight: 400;
  font-style: Regular;
  font-size: 24px;
  leading-trim: NONE;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  margin-top: 44px;

  @media (max-width: 499px) {
    width: 90%;
    font-size: 20px;
    margin-bottom: 36px;
    margin-top: 36px;
  }

`

export const DetailsContainer = styled.div`
  width: 95%;
  margin: 0 2.5%;
  font-family: Nexa Bold;
  font-weight: 700;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 100%;
  letter-spacing: 0px;
  vertical-align: middle;

  @media (max-width: 768px) {
    font-size: 15px
  }

`